import api from "./axios";
import {
  Organizacoes,
  PessoaDetalhe,
  PessoaLista,
  TrocaOrganizacaoResposta,
} from "../interfaces/Identidade";

/** Organizações às quais a pessoa logada pertence e qual está ativa no token. */
export const getOrganizacoes = async (): Promise<Organizacoes> =>
  (await api.get("/me/organizacoes")).data;

/** Troca a organização atual. Devolve par novo de tokens (o chamador grava com `saveSession`). */
export const trocarOrganizacao = async (clientId: number): Promise<TrocaOrganizacaoResposta> =>
  (await api.post("/me/organizacao-atual", { clientId })).data;

/* ---- Administração de pessoas (permissão `identidade.admin`) ---- */

const ADMIN = "/admin/identidade";

/** Lista paginada (20 por página); `busca` casa nome ou e-mail principal. */
export const getPessoas = async (busca: string, pagina = 1): Promise<PessoaLista> =>
  (await api.get(`${ADMIN}/pessoas`, { params: { busca: busca || undefined, pagina } })).data;

/** 404 se a pessoa não existe. */
export const getPessoa = async (id: number): Promise<PessoaDetalhe> =>
  (await api.get(`${ADMIN}/pessoas/${id}`)).data;

/** Cria o vínculo ou o reativa. 204; 400 se o cliente não existe. */
export const adicionarVinculo = async (pessoaId: number, clientId: number): Promise<void> => {
  await api.post(`${ADMIN}/pessoas/${pessoaId}/vinculos`, { clientId });
};

/** Desativa o vínculo (soft-delete). 204. */
export const desativarVinculo = async (pessoaId: number, clientId: number): Promise<void> => {
  await api.delete(`${ADMIN}/pessoas/${pessoaId}/vinculos/${clientId}`);
};

/** Substitui o conjunto de perfis do vínculo. 400 se algum perfil não existe ou está inativo. */
export const definirPerfisDoVinculo = async (vinculoId: number, profileIds: number[]): Promise<void> => {
  await api.put(`${ADMIN}/vinculos/${vinculoId}/perfis`, { profileIds });
};

/** Marca/desmarca a pessoa como equipe interna. 204. */
export const definirPessoaInterna = async (pessoaId: number, interna: boolean): Promise<void> => {
  await api.put(`${ADMIN}/pessoas/${pessoaId}/interna`, { interna });
};
